import { useRecoilState, useRecoilValue } from "recoil";
import { tokenListState } from "../atom/atom";
import { Token } from "../types/type";
import PushNotificationForm from "../components/PushNotificationForm";
import { copyTextToClipboard } from "../tools/tools";
import { useEffect } from "react";
import { fetchAndSetData, fetchTokenList } from "../api/fetch.api";

function SongRequestPage() {
  const [tokenList, setTokenList] = useRecoilState(tokenListState);

  const loggedInTokenList = tokenList.filter((token: Token) => token.email);
  const nonLoggedInTokenList = tokenList.filter((token: Token) => !token.email);

  const formatDate = (timestamp: any) => {
    if (!timestamp) return "";
    const date = timestamp.toDate();
    return date.toLocaleString(); // Convert to a locale string format
  };

  useEffect(() => {
    fetchAndSetData(fetchTokenList, setTokenList);
  }, []);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Token Data</h1>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <div
          style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}
        >
          <h2>로그인</h2>
          <h2>{loggedInTokenList.length}명</h2>
        </div>
        {loggedInTokenList.map((token: Token) => (
          <div
            key={token.fcmToken}
            style={{
              border: "1px solid #ccc",
              margin: "10px",
              padding: "10px",
            }}
          >
            <p
              style={{ cursor: "pointer" }}
              onClick={() => copyTextToClipboard(token.fcmToken)}
            >
              토큰: {token.fcmToken}
            </p>
            <p>유저 이메일: {token.email}</p>
            <p>유저 이름: {token.userName}</p>
            <p>플랫폼: {token.platform}</p>
            <p>마지막 접속: {formatDate(token.recentlyUseAt)}</p>
            <button
              onClick={() => window.alert("훼이크")}
              style={{ padding: "5px", marginTop: "10px" }}
            >
              알림 보내기
            </button>
          </div>
        ))}
      </div>

      <div style={{ marginBottom: "20px" }}>
        <div
          style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}
        >
          <h2>비로그인</h2>
          <h2>{nonLoggedInTokenList.length}명</h2>
        </div>

        {nonLoggedInTokenList.map((token: Token) => (
          <div
            key={token.fcmToken}
            style={{
              border: "1px solid #ccc",
              margin: "10px",
              padding: "10px",
            }}
          >
            <p>토큰: {token.fcmToken}</p>
            <p>플랫폼: {token.platform}</p>
            <p>마지막 접속: {formatDate(token.recentlyUseAt)}</p>
          </div>
        ))}
      </div>
    </>
  );
}

export default SongRequestPage;
